module.exports = __webpack_public_path__ + "static/banner-scanner-e0f43f9a5121a17ecc5f1aeaf53460e9.png";